/** Persist before sending; a lost response must replay the same admin instruction. */
export async function postAdminAdjustment(
  url: string,
  terms: Record<string, unknown>,
  headers: HeadersInit,
) {
  const key = "admin-adjustment:" + url + ":" + JSON.stringify(terms);
  let reference = sessionStorage.getItem(key);
  if (!reference) {
    reference = crypto.randomUUID();
    sessionStorage.setItem(key, reference);
  }
  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({ ...terms, adjustmentKey: reference }),
  });
  if (response.ok) sessionStorage.removeItem(key);
  return response;
}
